import {
  EXPORT_GRAPH,
  EXPORT_NETWORK_MAP,
  GET_MOST_CONNECTED,
  GET_TOP_CONNECTIONS,
  REMOVE_GRAPH_ITEMS,
  SET_GRAPH_ITEMS,
  SET_IS_LOADING,
  SET_MOST_CONNECTED,
  SET_MOST_CONNECTED_LOADING,
  SET_PEER_VIEW,
  SET_RESET_VIEW,
  SET_SEARCH_CONTEXT,
  SET_SELECTED_LINK,
  SET_SELECTED_VERTEX,
  SET_TOP_CONNECTIONS,
  SET_TOP_CONNECTIONS_LOADING,
  SET_VIEW,
  SET_FOCUSED_NODE,
  UPDATE_SEARCH_CONTEXT_DISPLAY,
  GET_RELATIONSHIP_SUGGESTIONS,
  SET_RELATIONSHIP_SUGGESTIONS,
  SET_RELATIONSHIP_SUGGESTIONS_LOADING,
  DISMISS_RELATIONSHIP_SUGGESTION,
  CONFIRM_RELATIONSHIP_SUGGESTION,
  SET_ACTIVE_SUGGESTION_PANEL,
  SET_SELECTED_SUGGESTED_EDGE,
  CLEAR_SUGGESTIONS,
  CLEAR_SUGGESTIONS_FOR_SOURCE,
  SET_CONFIRMATION_RESULT,
} from './constants';
import { REMOVE_NL_MESSAGE } from 'store/nl/actions';

// item: [{item}]
export const setGraphItem = (context, newNodes, newLinks, nodeCount) => {
  return {
    type: SET_GRAPH_ITEMS,
    context,
    newNodes,
    newLinks,
    nodeCount,
  };
};

export const setIsLoadingGraphItems = (value) => {
  return {
    type: SET_IS_LOADING,
    value,
  };
};

export const updateSearchContextDisplay = (context) => {
  return {
    type: UPDATE_SEARCH_CONTEXT_DISPLAY,
    context,
  };
};

export const removeGraphItem = (contextId) => {
  return {
    type: REMOVE_GRAPH_ITEMS,
    contextId,
  };
};

export const setSelectedVertex = (vertex) => {
  return {
    type: SET_SELECTED_VERTEX,
    vertex,
  };
};

// Dispatching SET_FOCUSED_NODE for any non-null id ALWAYS increments
// `focusPingTick` in the reducer (F-05), even when the id is unchanged.
// The reducer keeps the `focusedNode` value stable when it doesn't
// actually change (so chart memos don't invalidate), but the tick lets
// the focus useEffect re-fire fit + ping on repeat clicks.
export const setFocusedNode = (nodeId) => {
  return {
    type: SET_FOCUSED_NODE,
    nodeId,
  };
};

export const getTopConnections = (label, id, region) => {
  return {
    type: GET_TOP_CONNECTIONS,
    payload: {
      type: 'vertex',
      label,
      id,
      metroRegion: region,
    },
  };
};

export const setTopConnectionsLoading = (value) => {
  return {
    type: SET_TOP_CONNECTIONS_LOADING,
    value,
  };
};

export const setTopConnections = (id, payload) => {
  return {
    type: SET_TOP_CONNECTIONS,
    id,
    payload,
  };
};

export const getMostConnected = (label, id, region) => {
  return {
    type: GET_MOST_CONNECTED,
    payload: {
      type: 'vertex',
      label,
      id,
      metroRegion: region,
    },
  };
};

export const setMostConnectedLoading = (value) => {
  return {
    type: SET_MOST_CONNECTED_LOADING,
    value,
  };
};

export const setMostConnected = (id, payload) => {
  return {
    type: SET_MOST_CONNECTED,
    id,
    payload,
  };
};

export const setSelectedLinkId = (linkId) => {
  return {
    type: SET_SELECTED_LINK,
    linkId,
  };
};

export const setSearch = (search, refresh = false) => {
  return {
    type: SET_SEARCH_CONTEXT,
    search,
    refresh,
  };
};

export const setView = (view, context, refresh = false) => {
  return {
    type: SET_VIEW,
    view,
    context,
    refresh,
  };
};

export const setResetView = (context) => {
  return {
    type: SET_RESET_VIEW,
    context,
  };
};

export const setPeerView = (lookIds) => {
  return {
    type: SET_PEER_VIEW,
    lookIds,
  };
};

export const setSearchContext = (payload) => {
  return {
    type: SET_SEARCH_CONTEXT,
    payload,
  };
};

export const exportGraph = () => {
  return {
    type: EXPORT_GRAPH,
  };
};

export const exportNetworkMap = () => {
  return {
    type: EXPORT_NETWORK_MAP,
  };
};

export const removeAIContext = (contextId) => {
  return {
    type: REMOVE_NL_MESSAGE,
    contextId,
  };
};

export const getRelationshipSuggestions = (personId, signals) => ({
  type: GET_RELATIONSHIP_SUGGESTIONS,
  payload: { personId, signals },
});

export const setRelationshipSuggestions = (sourcePersonId, suggestions) => ({
  type: SET_RELATIONSHIP_SUGGESTIONS,
  payload: { sourcePersonId, ...suggestions },
});

export const setRelationshipSuggestionsLoading = (isLoading) => ({
  type: SET_RELATIONSHIP_SUGGESTIONS_LOADING,
  payload: isLoading,
});

export const dismissRelationshipSuggestion = (personId1, personId2) => ({
  type: DISMISS_RELATIONSHIP_SUGGESTION,
  payload: { personId1, personId2 },
});

export const confirmRelationshipSuggestion = (
  personId1,
  personId2,
  relationshipType,
  signals = [],
  details = null,
) => ({
  type: CONFIRM_RELATIONSHIP_SUGGESTION,
  payload: {
    suggestion: {
      personId1,
      personId2,
      signals,
      details,
    },
    relationshipType,
  },
});

export const setActiveSuggestionPanel = (personId) => ({
  type: SET_ACTIVE_SUGGESTION_PANEL,
  payload: personId,
});

export const setSelectedSuggestedEdge = (edgeKey) => ({
  type: SET_SELECTED_SUGGESTED_EDGE,
  payload: edgeKey,
});

export const setConfirmationResult = (result) => ({
  type: SET_CONFIRMATION_RESULT,
  payload: result,
});

export const clearSuggestions = () => ({
  type: CLEAR_SUGGESTIONS,
});

export const clearSuggestionsForSource = (sourcePersonId) => ({
  type: CLEAR_SUGGESTIONS_FOR_SOURCE,
  payload: { sourcePersonId },
});
